import { captureAnalyticsEvent } from '@/lib/mixpanel';
import { useAuthStore } from '@/stores/authStore';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export const usePageViewTracker = () => {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);

  const { status } = useAuthStore();

  useEffect(() => {
    if (status !== 'AUTHENTICATED') return;

    const path = location.pathname;

    // Avoid firing on identical paths (React strict mode may mount twice)
    if (previousPath.current === path) return;

    void captureAnalyticsEvent('page_view', {
      path,
      previousPath: previousPath.current,
    });

    previousPath.current = path;
  }, [location.pathname, status]);
};
